import styled from "styled-components";

export const AppContainer = styled.div`
  background-color: #f5f5f5;
  min-height: 100vh;
  display: flex;
  justify-content: center;
`;

export const MainContent = styled.div<{
  $noBottomPadding?: boolean;
  $isUnauthRoute?: boolean;
}>`
  max-width: 768px;
  width: 100%;
  background-color: ${(props) => (props.$isUnauthRoute ? "transparent" : "white")};
  min-height: 100vh;
  padding-bottom: ${(props) => (props.$noBottomPadding ? "0" : "100px")};
`;